import api from '@/services/api';

export default {
  async fetchLocations(location: string) {
    return api.fetch(`/places?q=${location}`, 'GET');
  },
};
